$(document).ready(function () {
      //toggle the component with class accordion_body
      $(".accordion_head").click(function () {
          if ($('.accordion_body').is(':visible')) {
              $(".accordion_body").slideUp(300);
              $(".plusminus").text('+');
          }
          if ($(this).next(".accordion_body").is(':visible')) {
              $(this).next(".accordion_body").slideUp(300);
              $(this).children(".plusminus").text('+');
          } else {
              $(this).next(".accordion_body").slideDown(300);
              $(this).children(".plusminus").text('-');
          }
      });
  });


$(document).ready(function () {
    //toggle the component with class accord_body
    $(".accord_heading").click(function () {
        if ($('.accord_body').is(':visible')) {
            $(".accord_body").slideUp(300);
            $(".plus__minus").text('+');
        }
        if ($(this).next(".accord_body").is(':visible')) {
            $(this).next(".accord_body").slideUp(300);
            $(this).children(".plus__minus").text('+');
        } else {
            $(this).next(".accord_body").slideDown(300);
            $(this).children(".plus__minus").text('-');
        }
    });
});

$(document).ready(function () {
    $(".accord_heading").on("click", function () {
        const $currentAccordion = $(this).closest(".main-accordion");

        // If the current accordion already has the class, remove it
        if ($currentAccordion.hasClass("inc_width")) {
            $currentAccordion.removeClass("inc_width");
        } else {
            // Remove 'inc_width' from all accordions
            $(".main-accordion").removeClass("inc_width");

            // Add 'inc_width' to the clicked accordion
            $currentAccordion.addClass("inc_width");
        }
    });
});